window.mcb = window.mcb || {};
window.mcb.effects = window.mcb.effects || {};
window.mcb.effects.helpers = window.mcb.effects.helpers || {};
window.mcb.tracking = window.mcb.tracking || {};
window.mcb.utilities = window.mcb.utilities || {};
